module.exports = __webpack_public_path__ + "img/Constructeurs.a613a0d5.png";